import { render, staticRenderFns } from "./c-Soal.vue?vue&type=template&id=099991a2&scoped=true&"
import script from "./c-Soal.vue?vue&type=script&lang=js&"
export * from "./c-Soal.vue?vue&type=script&lang=js&"
import style0 from "./c-Soal.vue?vue&type=style&index=0&id=099991a2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "099991a2",
  null
  
)

export default component.exports